import { CATEGORY_TYPE } from 'models/documents.model';

export enum DOCUMENT_PUBLICATION_STATUS {
  PREPARED_TO_SIGN = 'PREPARED_TO_SIGN',
  PUBLISHING_ERROR = 'PUBLISHING_ERROR',
  PUBLISHING_INITIATED = 'PUBLISHING_INITIATED',
  PUBLISHING_OK = 'PUBLISHING_OK',
}

export enum DOCUMENT_TYPE {
  ALL = 'ALL',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export enum FORGETTING_STATUS {
  FORGETTING_EXCEPTION = 'FORGETTING_EXCEPTION',
  FORGETTING_IN_PROGRESS = 'FORGETTING_IN_PROGRESS',
  FORGETTING_OK = 'FORGETTING_OK',
}

export enum PUBLICATION_MODE {
  CORRECTED = 'CORRECTED',
  NEW = 'NEW',
  UPDATED = 'UPDATED',
}

export enum PUBLICATION_ERROR {
  PRODUCT_ID_ALREADY_EXISTS = 'PRODUCT_ID_ALREADY_EXISTS',
}

export enum DOCUMENT_STATUS {
  CURRENT = 'CURRENT',
  DEPRECATED = 'DEPRECATED',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  NOT_EXIST = 'NOT_EXIST',
  PREPARED_TO_SIGN = 'PREPARED_TO_SIGN',
  UPLOADING = 'UPLOADING',
}

export enum DOCUMENT_GROUP {
  ERROR = 'ERROR',
  NEW = 'NEW',
}

export enum CERTIFICATE_SOURCES {
  MINED = 'Mined',
  RECYCLED = 'Recycled',
}

export enum CERTIFICATE_REVIEW_STATUS {
  REJECTED = 'Rejected',
  APPROVED = 'Approved',
  NOT_PROVIDED = 'Not provided',
}

export enum CERTIFICATE_HEALTH_DESCRIPTION {
  POOR = 'Poor',
  FAIR = 'Fair',
  GOOD = 'Good',
  VERY_GOOD = 'Very Good',
}

export type UserGetDocumentListViewModel = {
  firstName: string;
  id: string;
  lastName: string;
  username: string;
};

export type IdentityGetDocumentListViewModel = {
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  phoneNumber: string;
};

export type CertificateHistoryModel = {
  documentBlockchainAddress: string;
  publicationDate: string;
  publicationMode: PUBLICATION_MODE;
  status: DOCUMENT_STATUS;
  title: string;
  validUntil: string;
};

export type DocumentModel<AdditionalDetailsType> = {
  category: CATEGORY_TYPE;
  documentBlockchainAddress: string;
  documentPublicationStatus: DOCUMENT_PUBLICATION_STATUS;
  documentType: DOCUMENT_TYPE;
  forgettingStatus: FORGETTING_STATUS;
  identity: IdentityGetDocumentListViewModel;
  jobId: string;
  publicationDate?: string;
  publicationDelayMinutes: number;
  publicationMode: PUBLICATION_MODE;
  publicationStartDate: string;
  publishedBy: UserGetDocumentListViewModel;
  retainUntil: string;
  status: DOCUMENT_STATUS;
  title: string;
  validSince: string;
  validUntil: string;
  versionName: string;
  additionalDetails?: AdditionalDetailsType;
  read: boolean;
  favourite: boolean;
  senderPublisherId?: string;
  receiverPublisherId?: string;
  draft?: boolean;
  history: CertificateHistoryModel[];
};

export type DocumentDetailsModel<AdditionalDetailsType> = DocumentModel<AdditionalDetailsType> & {
  fileName: string;
  fileSize: number;
};

export type RecipientsToNotify = {
  groups: DOCUMENT_GROUP;
  idList: string[];
};

export type GetDocumentFilters = {
  categoryId?: number;
  creationDateRange?: {
    from?: string;
    to?: string;
  };
  documentStatusList?: DOCUMENT_STATUS;
  documentType?: DOCUMENT_TYPE;
  identity?: {
    documentNumber?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
  };
  legalValidityFinishDateRange?: {
    from?: string;
    to?: string;
  };
  legalValidityStartDateRange?: {
    from?: string;
    to?: string;
  };
  publicationDateRange?: {
    from?: string;
    to?: string;
  };
  publicationStatusList?: DOCUMENT_PUBLICATION_STATUS;
  publishedBy?: string;
  retentionDateRange?: {
    from?: string;
    to?: string;
  };
  signatoryId?: string;
  title?: string;
  additionalDetails?: {
    recipient?: string;
  };
  draft?: boolean;
};

export type GetDocumentPagination = {
  limit?: number;
  page?: number;
};

export enum SORT_ORDER {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING  ',
}

export enum SORT_BY {
  CATEGORY = 'CATEGORY',
  LEGAL_VALIDITY_FINISH_DATE = 'LEGAL_VALIDITY_FINISH_DATE',
  LEGAL_VALIDITY_START_DATE = 'LEGAL_VALIDITY_START_DATE',
  PUBLICATION_DATE = 'PUBLICATION_DATE',
  SURNAME = 'SURNAME',
  TITLE = 'TITLE',
}
export type GetDocumentSort = {
  order?: SORT_ORDER;
  sortBy?: SORT_BY;
};
